import { InjectionToken } from '@angular/core';

export const LEGACY_MODE = new InjectionToken<boolean>('LEGACY_MODE');

export const LEGACY_MODE_CONFIG = new InjectionToken<LegacyModeConfig>(
  'LEGACY_MODE_CONFIG',
);

export interface LegacyModeConfig {
  legacyMode?: boolean;
}
